import { X } from "lucide-react";

export const ORANGE = "#ED8B00";

export const Btn = ({ variant = "primary", className = "", ...p }) => {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-md px-3.5 py-2 text-sm font-semibold transition-colors disabled:opacity-50";
  const styles = {
    primary: "bg-[#ED8B00] text-white hover:bg-[#d67e00]",
    ghost: "text-slate-300 hover:bg-slate-800 hover:text-white",
    outline: "border border-slate-300 text-slate-700 hover:border-[#ED8B00] hover:text-[#ED8B00]",
    danger: "border border-red-300 text-red-600 hover:bg-red-50",
    subtle: "bg-slate-100 text-slate-700 hover:bg-slate-200",
  };
  return <button className={`${base} ${styles[variant]} ${className}`} {...p} />;
};

export const Field = ({ label, children }) => (
  <label className="block">
    <span className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">{label}</span>
    {children}
  </label>
);

export const Input = (p) => (
  <input
    className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm outline-none focus:border-[#ED8B00] focus:ring-1 focus:ring-[#ED8B00]"
    {...p}
  />
);

export const Textarea = (p) => (
  <textarea
    className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm outline-none focus:border-[#ED8B00] focus:ring-1 focus:ring-[#ED8B00]"
    {...p}
  />
);

export const Select = ({ children, ...p }) => (
  <select
    className="w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm outline-none focus:border-[#ED8B00]"
    {...p}
  >
    {children}
  </select>
);

export const Modal = ({ open, onClose, title, children, wide = false, testId }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/50 p-4 pt-16" data-testid={testId}>
      <div className={`w-full ${wide ? "max-w-3xl" : "max-w-lg"} rounded-xl bg-white shadow-2xl`}>
        <div className="flex items-center justify-between border-b border-slate-200 px-5 py-3.5">
          <h3 className="font-heading text-lg font-bold text-slate-900">{title}</h3>
          <button onClick={onClose} className="rounded-md p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-700" data-testid="modal-close">
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="px-5 py-4">{children}</div>
      </div>
    </div>
  );
};

export const Badge = ({ children, color = "slate" }) => {
  const c = {
    slate: "bg-slate-100 text-slate-600",
    green: "bg-emerald-100 text-emerald-700",
    orange: "bg-orange-100 text-orange-700",
    blue: "bg-blue-100 text-blue-700",
    red: "bg-red-100 text-red-700",
    purple: "bg-purple-100 text-purple-700",
  }[color];
  return <span className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-semibold ${c}`}>{children}</span>;
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return "—";
  }
};
